/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normality Calculator — Toolverse`)
};

const es_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Normalidad — Toolverse`)
};

const de_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalitätsrechner — Toolverse`)
};

const nl_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaliteitscalculator — Toolverse`)
};

const fr_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de normalité — Toolverse`)
};

const it_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di normalità — Toolverse`)
};

const pt_br2_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Normalidade — Toolverse`)
};

const pt_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Normalidade — Toolverse`)
};

const ja_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規定度計算ツール — Toolverse`)
};

const zh_norm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量浓度计算器 — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_meta_title", locale)
	if (locale === "en") return en_norm_meta_title(inputs)
	if (locale === "es") return es_norm_meta_title(inputs)
	if (locale === "de") return de_norm_meta_title(inputs)
	if (locale === "nl") return nl_norm_meta_title(inputs)
	if (locale === "fr") return fr_norm_meta_title(inputs)
	if (locale === "it") return it_norm_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_norm_meta_title(inputs)
	if (locale === "pt") return pt_norm_meta_title(inputs)
	if (locale === "ja") return ja_norm_meta_title(inputs)
	return zh_norm_meta_title(inputs)
};